export const inputCls = "w-full h-12 rounded-lg border-2 border-slate-300 bg-white px-3 text-base text-slate-900 focus:border-slate-900 focus:outline-none";

export const F = ({ label, id, children, hint }) => (
  <div className="space-y-1.5">
    <label htmlFor={id} className="block text-base font-medium text-slate-800">{label}</label>
    {children}
    {hint && <p className="text-sm text-slate-500">{hint}</p>}
  </div>
);

export const TextIn = ({ id, label, hint, ...p }) => (
  <F label={label} id={id} hint={hint}>
    <input id={id} data-testid={`kyc-${id}`} className={inputCls} {...p} />
  </F>
);

export const SelectIn = ({ id, label, options, placeholder = "Elige una opción", hint, ...p }) => (
  <F label={label} id={id} hint={hint}>
    <select id={id} data-testid={`kyc-${id}`} className={inputCls} {...p}>
      <option value="">{placeholder}</option>
      {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  </F>
);

export const Group = ({ title, children }) => (
  <fieldset className="space-y-4 bg-white border border-slate-200 rounded-xl p-4">
    <legend className="font-heading font-semibold text-lg text-slate-900 px-1">{title}</legend>
    {children}
  </fieldset>
);
